if (!customElements.get("userlike-button")) {
  class UserlikeButton extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector(".userlike-open-button");
      this.loaded = false;
      this.consent = this.dataset.consent;
      this.designMode = this.dataset.designMode;
      this.widgetKey = this.dataset.key;
      this.userlikeApi = null;
      this.active = false;
      this.init()
    }

    init() {
      this.moveButton();
      this.addListeners();
      window.Shopify.loadFeatures(
        [
          {
            name: "consent-tracking-api",
            version: "0.1",
          },
        ],
        error => {
          if (error) {
            console.error("Error loading Shopify API:", error);
            return;
          }
          // we can instantly load the button if no consent is required
          // otherwise the liseners will take care of loading the button
          var currentConsent = Shopify.customerPrivacy.currentVisitorConsent();
          if (
            this.consent === "always" ||
            (this.consent === "marketing-advertising" && currentConsent.marketing === "yes") ||
            (this.consent === "analytics" && currentConsent.analytics === "yes") ||
            (this.consent === "preferences-functional" && currentConsent.preferences === "yes") ||
            this.designMode === "true"
          ) {
            // load messenger
            if ('requestAnimationFrame' in window) {
              requestAnimationFrame(() => {
                this.activate();
              });
            } else {
              setTimeout(() => {
                this.activate();
              }, 500);
            }
          } else {
            this.deactivate();
          }
          document.addEventListener("visitorConsentCollected", (event) => {
            if (
              (event.detail.firstPartyMarketingAllowed && this.consent === "marketing-advertising") ||
              (event.detail.analyticsAllowed && this.consent === "analytics") ||
              (event.detail.preferencesAllowed && this.consent === "preferences-functional")
            ) {
              if ('requestAnimationFrame' in window) {
                requestAnimationFrame(() => {
                  this.activate();
                });
              } else {
                setTimeout(() => {
                  this.activate();
                }, 500);
              }
            } else {
              this.deactivate();
            }
          });
        }
      );
    }

    activate() {
      if (this.active) return;
      this.active = true;
      fetch('https://userlike-cdn-widgets.s3-eu-west-1.amazonaws.com/'+this.widgetKey+'.json').then(res => res.json()).then(data => {
        const orgId = data.organization_id;
        const widgetId = data.um_widget_id;

        fetch('https://api.userlike.com/api/um/chat/button/check/?organization_id='+orgId+'&chat_widget_id='+widgetId, {
          headers: {
            'accept': 'application/json'
          }
        }).then(res => res.json()).then(data => {
          if (data.can_start_conversation) {
            this.button.classList.add("visible");
          }
        });
      });
    }

    deactivate() {
      this.active = false;
      this.button.classList.remove("visible");
    }

    // add https://unpkg.com/@userlike/messenger/dist/browser/index.min.js to head
    loadUserlikeApi() {
      return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src =
          "https://unpkg.com/@userlike/messenger/dist/browser/index.min.js";
        script.type = "text/javascript";
        script.async = true;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });
    }

    addListeners() {
      this.button.addEventListener("click", this.handleClick.bind(this));
    }

    deactivationObserver(cb) {
      const userlikeFrame = document.querySelector('iframe[id^="userlike"]');
      if (!userlikeFrame) return;
      const origFetch = userlikeFrame.contentWindow.fetch;
      userlikeFrame.contentWindow.fetch = function() {
        var args = [].slice.call(arguments);
        var result = origFetch.apply(this, args);
        result.then(function(response) {
          if (response.url.includes('api.userlike.com/api/um/chat/button/check')) { 
            response.clone().json().then(data => {
              if (!data.can_start_conversation) {
                cb();
              }
            });
          }
        });
        return result;
      };
    }

    async handleClick() {
      // return when the packages are already loading to prevent multiple loads
      if (this.button.classList.contains("loading")) return;
      // return when the widget is not active
      if (!this.active) return;

      if (this.loaded) {
        await this.userlikeApi.maximize();
        return;
      }

      this.button.classList.add("loading");

      // we need to load the userlike api first
      await this.loadUserlikeApi();

      // create the messenger api
      var result = await UserlikeMessenger.createMessenger({
        version: 1,
        widgetKey: this.widgetKey,
      });
      if (result.kind === "error") throw new Error(result.error);
      this.userlikeApi = result.value.api;

      // mount the messenger and set options
      await this.userlikeApi.mount();
      await this.userlikeApi.setVisibility({
        main: true,
        button: false,
        notifications: false,
      });

      // we're done, next time the button is clicked we can just maximize the messenger
      this.loaded = true;

      // observe the userlike iframe, intercept api and use it to deactivate the button when the chat is not available
      this.deactivationObserver(this.deactivate.bind(this));

      // maximize messenger using an interval because sometimes the messenger doesn't open even when using the mount callback
      var interval = setInterval(async () => {
        if (this.userlikeApi.getState().state !== "maximized") {
          await this.userlikeApi.maximize();
        } else {
          this.button.classList.remove("loading");
          clearInterval(interval);
        }
      }, 250);
    }

    // append to body element
    moveButton() {
      document.body.appendChild(this);
    }
  }

  customElements.define("userlike-button", UserlikeButton);
}
